( function ( windowObject, documentObject, config ) {
	'use strict';

	if ( ! windowObject || ! documentObject || ! config ) {
		return;
	}

	function initHeroSearch( block ) {
		const simpleSelects = block.querySelectorAll( '.select2-init-field' );
		const bakerySelect = block.querySelector( '.js-hero-bakery-select' );

		if (
			simpleSelects.length &&
			windowObject.SweettySpaceSelect &&
			windowObject.SweettySpaceSelect.initSimpleSelect2
		) {
			windowObject.SweettySpaceSelect.initSimpleSelect2( simpleSelects );
		}

		if (
			! bakerySelect ||
			! windowObject.SweettySpaceSelect ||
			! windowObject.SweettySpaceSelect.initRemoteBakerySelect
		) {
			return;
		}

		windowObject.SweettySpaceSelect.initRemoteBakerySelect(
			bakerySelect,
			Object.assign( {}, config, {
				sourceGroup: 'hero_search',
			} )
		);
	}

	documentObject.addEventListener( 'DOMContentLoaded', function () {
		documentObject
			.querySelectorAll( '.wp-block-sweettyspace-hero' )
			.forEach( function ( block ) {
				initHeroSearch( block );
			} );
	} );
} )( window, document, window.SweettySpaceHeroSearch );
